import React from 'react';
import PropTypes from 'prop-types';
import { FlatButton, Dialog } from 'material-ui';
import { FormattedDate, FormattedTime } from 'react-intl';
import { RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import { DateStyles } from '../../constants/CentricConstants';
import { asDialog } from '../Common/Decorators';
import { ModuleDialogs } from '../../constants/Dialogs';
import DialogActions from '../../actions/DialogActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';

const SwitchRegistrationDialog = ({open, draft, history, currentId}) => (
    <Dialog
        title="Attempts"
        open={open === ModuleDialogs.SWITCH_REGISTRATION_DIALOG}
        onRequestClose={() => DialogActions.close()}
        actions={[
            <FlatButton key="btn-cancel" label="Cancel" onTouchTap={() => DialogActions.close()} />,
            <FlatButton
                key="btn-switch"
                label="Switch"
                primary={true}
                disabled={!draft.guid || draft.guid === currentId}
                onTouchTap={() => ModuleActions.switchRegistration(draft.guid).then(() => DialogActions.close()) }
            />
        ]}
    >
        <div>You may substitute your current attempt with a previous result.</div>
        <RadioButtonGroup
            name="registration"
            onChange={(e, value) => DialogActions.updateDraft('guid', value) }
            value={draft.guid}
            defaultSelected={currentId}
            className="cent-radio-button-group"
        >
            {history.map(({ guid, success, score, dateUpdated, dateExpires }) => (
                <RadioButton
                    key={guid}
                    value={guid}
                    label={(
                        <span>
                            <strong>{score}%</strong> <em>on <FormattedDate value={dateUpdated} {...DateStyles.long} /> at <FormattedTime value={dateUpdated} /></em>
                            {!!dateExpires && (<em>, expires on <FormattedDate value={dateExpires} {...DateStyles.long} /> at <FormattedTime value={dateExpires} /></em>)}
                        </span>
                    )}
                />
            ))}
        </RadioButtonGroup>
    </Dialog>
);

SwitchRegistrationDialog.propTypes = {
    history: PropTypes.arrayOf(
        PropTypes.shape({
            guid: PropTypes.string.required,
            dateUpdated: PropTypes.object.required,
            score: PropTypes.number.required,
            success: PropTypes.string.required,
        })
    ),
    currentId: PropTypes.string,
};


export default asDialog(SwitchRegistrationDialog);
